import * as React from 'react'
import { MergeIcon } from '~/components/icons/branch-icon'
import { useBranchMergeDiff } from '../../_hooks/use-merge-diff'
import { useSelectedBranchOrCommitQuery } from '~/lib/commits/use-selected-branch-or-commit'
import { isCommit } from '@basehub/data/replicache/index'
import { READMEIcon } from '~/components/icons/readme'
import { CommitIcon } from '@radix-ui/react-icons'
import { clsx } from 'clsx'

export const TimelineTabIcon = ({ className }: { className?: string }) => {
  const branchOrCommit = useSelectedBranchOrCommitQuery().data
  const { status } = useBranchMergeDiff({
    branch: !branchOrCommit || isCommit(branchOrCommit) ? null : branchOrCommit,
  })

  if (
    !branchOrCommit ||
    (!isCommit(branchOrCommit) && branchOrCommit.isDefault)
  ) {
    return <READMEIcon className={clsx('size-[18px]', className)} />
  }

  if (isCommit(branchOrCommit)) {
    return <CommitIcon className={clsx('size-[18px]', className)} />
  }

  if (status === 'conflicts') {
    return (
      <span
        aria-label="Branch has unresolved conflicts"
        className={clsx(
          'shadow-2xl min-w-max pointer-events-none select-none top-3/4 text-xs inline-flex size-4 items-center text-dark-base justify-center rounded-full bg-warning text-center font-bold leading-none',
          className
        )}
      >
        !
      </span>
    )
  }

  return (
    <span
      aria-label={status === 'merged' ? 'Branch merged' : 'Branch open'}
      className={clsx(
        'shadow-2xl min-w-max pointer-events-none select-none top-3/4 text-[11px] inline-flex size-[18px] items-center justify-center rounded-full text-center font-medium leading-none',
        className
      )}
    >
      <MergeIcon />
    </span>
  )
}
